// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"41":"error","930":"tables"}[chunkId] + "." + {"41":"0bd03412","930":"a1bd7473"}[chunkId] + ".css";
};